import React from "react";
import "./Ressourcen/Calender.css"
import Project from "./Project"


function Calender(props) {
    const {data, dates, filter_name, expendet_datebar} = props;
    const datebar_style = {width: get_width(0, 0, dates.length) + '%'};
    let top = expendet_datebar ? 80 : 49;
    return (<div className={"cal_container"}>
            <div className={"date_bar"} style={{top: top + "px"}}>
                {dates.map((tag, index) => (<div key={index} className={"date"} style={datebar_style}>
                        <p>{tag}</p>
                    </div>))}
            </div>
            {data.standorte.map((standort, index) => (<div key={index} className={"location_container"}>
                    <Standort key={index} name={standort.name} customers={standort.customer}
                              general_duration={dates.length} filter_name={filter_name}/>
                </div>))}

        </div>);

}


function Standort(props) {

    const {name, customers, general_duration, filter_name} = props;
    return (<>
            <div className={"col "} style={{marginBottom: "10px",border: "2px solid white",
                borderRadius: "10px"}}>
                <div style={{
                    color: "white",
                    padding: "5px",

                    fontWeight: "bold"
                }}>
                    <p>{name}</p>
                </div>

                {customers.map((customer, index) => (<div key={index} className={"customer_container"}>
                        <Customer key={index} projects={customer.projects} name={customer.name}
                                  general_duration={general_duration} filter_name={filter_name}/>
                    </div>))}
            </div>

        </>


    );

}

function Customer(props) {
    const {name, projects, general_duration, filter_name} = props

    return (

        <div className={"col "} style={{marginBottom: "5px", backgroundColor: "lightblue", borderRadius: "10px"}}>
            <div style={{backgroundColor: "lightblue", padding: "7px", borderRadius: "10px"}}>
                <p style={{fontWeight: "bold", borderRadius: "10px"}}>{name}</p>
            </div>
            {projects.map((project, index) => (<Project key={index} project_details={project}
                                                        general_duration={general_duration}
                                                        background={index % 2 === 0 ? '#ffffff' : 'rgba(235, 235, 235, 0.80)'}
                                                        filter_name={filter_name}/>))}
        </div>


    );
}

export function get_duration(start_day, endday) {
    return endday - start_day + 1
}


export function get_width(start_day, endday, anzahl_tage) {
    let newVar = (100 / (anzahl_tage / (get_duration(start_day, endday))));
    return newVar
}

export function get_offset(start_day, anzahl_tage) {
    return ((100 / anzahl_tage) * start_day) + '%';
}


export default Calender